"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3990],{

/***/ 32118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SearchForm_Form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Label/Label.js
var Label = __webpack_require__(98028);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Select/Select.js
var Select = __webpack_require__(16031);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/theme/theme.js + 1 modules
var theme = __webpack_require__(15072);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/FormField/FormField.js
var FormField = __webpack_require__(23341);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(9922);
// EXTERNAL MODULE: ./node_modules/@pcln/date-picker/dist/esm/index.js + 67 modules
var esm = __webpack_require__(32018);
// EXTERNAL MODULE: ./src/components/StyledHeading/index.tsx
var StyledHeading = __webpack_require__(29293);
// EXTERNAL MODULE: ./src/components/CalenderWrapperBox.styled.ts
var CalenderWrapperBox_styled = __webpack_require__(2850);
// EXTERNAL MODULE: ./src/components/DateField.tsx
var DateField = __webpack_require__(43484);
// EXTERNAL MODULE: ./src/components/ShadowEffect.tsx
var ShadowEffect = __webpack_require__(10843);
// EXTERNAL MODULE: ./src/components/SearchFormButton/index.tsx
var SearchFormButton = __webpack_require__(17975);
// EXTERNAL MODULE: ./src/components/TypeAhead/index.tsx + 13 modules
var TypeAhead = __webpack_require__(21993);
// EXTERNAL MODULE: ./src/utils/date-helper.tsx
var date_helper = __webpack_require__(68511);
// EXTERNAL MODULE: ./src/components/Popover.tsx + 2 modules
var Popover = __webpack_require__(57812);
// EXTERNAL MODULE: ./src/components/TravelerSelection/constants.ts
var constants = __webpack_require__(45588);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/components/TravelerSelection/TravelerSelection.tsx + 9 modules
var TravelerSelection = __webpack_require__(47941);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/hooks/useTabGroup.ts
var useTabGroup = __webpack_require__(78474);
// EXTERNAL MODULE: ./src/hooks/useContentfulSearchFormHeadlines.ts
var useContentfulSearchFormHeadlines = __webpack_require__(98673);
// EXTERNAL MODULE: ./src/components/Packages/SearchForm/utils.ts
var utils = __webpack_require__(360);
// EXTERNAL MODULE: ./src/components/Packages/SearchForm/TripTypes.ts
var TripTypes = __webpack_require__(51217);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Radio/Radio.js + 2 modules
var Radio = __webpack_require__(47503);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 238 modules
var es = __webpack_require__(67763);
;// CONCATENATED MODULE: ./src/utils/ramda-helper.ts

// eslint-disable-next-line import/prefer-default-export
function swap(index1, index2, list) {
    if (index1 < 0 || index2 < 0 || index1 > list.length - 1 || index2 > list.length - 1) {
        return list // index out of bound
        ;
    }
    return (0,es/* pipe */.zGw)((0,es/* set */.t8m)((0,es/* lensIndex */.p_J)(index1), list[index2]), (0,es/* set */.t8m)((0,es/* lensIndex */.p_J)(index2), list[index1]))(list);
}

;// CONCATENATED MODULE: ./src/components/Packages/SearchForm/TripTypeRadios.tsx






var defaultTripTypes = Object.values(TripTypes/* TripTypeInfos */.jb);
var mobileDefaultTripTypes = swap(1, 2, defaultTripTypes);
function TripTypeRadios(param) {
    var setValue = param.setValue, watchTripType = param.watchTripType;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var tripTypes = isMobile ? mobileDefaultTripTypes : defaultTripTypes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        alignItems: [
            "left",
            null,
            "center"
        ],
        flexDirection: [
            "column",
            null,
            "row"
        ],
        justifyContent: "space-between",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            flexDirection: "row",
            flexWrap: "wrap",
            children: tripTypes.map(function(typeInfo) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    mr: [
                        0,
                        null,
                        3
                    ],
                    alignItems: "center",
                    width: isMobile ? 1 / 2 : "auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TripTypes/* TripTypeLabel */.sc, {
                        fontSize: 0,
                        fontWeight: 500,
                        nowrap: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                id: typeInfo.id,
                                type: "radio",
                                name: "tripType",
                                value: typeInfo.tripType,
                                checked: watchTripType === typeInfo.tripType,
                                onChange: function(e) {
                                    setValue("tripType", e.target.value, {
                                        shouldDirty: true
                                    });
                                }
                            }),
                            " ",
                            typeInfo.typeLabel
                        ]
                    })
                }, typeInfo.id);
            })
        })
    });
}
/* harmony default export */ var SearchForm_TripTypeRadios = (TripTypeRadios);

// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var index_esm = __webpack_require__(16310);
;// CONCATENATED MODULE: ./src/components/Packages/SearchForm/validation.ts


var LOCATION_REQUIRED = "Please enter a city or airport";
var INVALID_DATE = "Please select valid dates";
var DISALLOW_INFANT_INTL_FLIGHT = "Sorry, we do not offer lap infant seating on international flights";
var INFANT_CAPACITY_LIMIT = "Only one infant per adult is allowed";
var CHILD_AGE_REQUIRED = "Please enter children's age to get the best price for your group";
var MAXIMUM_BUNDLE_GUEST_COUNT = 8;
var BUNDLE_MAX_CAPACITY_ERROR = "Bundles accommodate up to 8 people. You may need an additional bundle for your group";
var intlStartLocation = function(startLocationObject) {
    return startLocationObject && typeof startLocationObject.countryCode === "string" && startLocationObject.countryCode.toUpperCase() !== "US";
};
var intlEndLocation = function(endLocationObject) {
    return endLocationObject && typeof endLocationObject.countryCode === "string" && endLocationObject.countryCode.toUpperCase() !== "US";
};
var isInfantFound = function(childrenAges) {
    return Array.isArray(childrenAges) && childrenAges.some(function(age) {
        return Number(age) === 0;
    });
};
var isStartLocationWithInfant = function(startLocationObject, childrenAges) {
    return intlStartLocation(startLocationObject) && isInfantFound(childrenAges);
};
var isEndLocationWithInfant = function(endLocationObject, childrenAges) {
    return intlEndLocation(endLocationObject) && isInfantFound(childrenAges);
};
var isChildrenAgeDataValid = function(childrenAges) {
    return Array.isArray(childrenAges) && childrenAges.length >= 0;
};
var numOfValidAges = function(childrenAges) {
    return Array.isArray(childrenAges) ? childrenAges.filter(function(age) {
        return age >= 0;
    }) : [];
};
var isInfantOnInternationalTravel = function(startLocation, endLocation, childrenAges) {
    if (isStartLocationWithInfant(startLocation, childrenAges) || isEndLocationWithInfant(endLocation, childrenAges)) {
        return DISALLOW_INFANT_INTL_FLIGHT;
    }
    return "";
};
function handleIsInfantOnInternationalTravel() {
    var _parent = this.parent, startLocation = _parent.startLocation, endLocation = _parent.endLocation, childrenAges = _parent.childrenAges;
    if (isStartLocationWithInfant(startLocation, childrenAges) || isEndLocationWithInfant(endLocation, childrenAges)) {
        return false;
    }
    return true;
}
var isRoomCompacityReached = function(adultCount, childrenCount) {
    var travelerCount = adultCount + childrenCount;
    if (MAXIMUM_BUNDLE_GUEST_COUNT < travelerCount) {
        return BUNDLE_MAX_CAPACITY_ERROR;
    }
    return "";
};
function handleIsRoomCompacityReached() {
    var _parent = this.parent, adultCount = _parent.adultCount, childrenCount = _parent.childrenCount, tripType = _parent.tripType;
    var travelerCount = adultCount + childrenCount;
    if (MAXIMUM_BUNDLE_GUEST_COUNT < travelerCount && (tripType.includes(TripTypes/* HOTEL */.IN) || tripType.includes(TripTypes/* CAR */.Ow))) {
        return false;
    }
    return true;
}
function handleIsChildrenAgeProvided() {
    var _parent = this.parent, childrenCount = _parent.childrenCount, childrenAges = _parent.childrenAges;
    if (childrenCount > 0 && isChildrenAgeDataValid(childrenAges) && childrenCount !== numOfValidAges(childrenAges).length) {
        return false;
    }
    return true;
}
var isChildrenAgeProvided = function(childrenCount, childrenAges) {
    if (childrenCount > 0 && isChildrenAgeDataValid(childrenAges) && childrenCount !== numOfValidAges(childrenAges).length) {
        return CHILD_AGE_REQUIRED;
    }
    return "";
};
var isInfantLimitReachedPackages = function(adultCount, childrenAges, tripType) {
    var lapInfants = (childrenAges === null || childrenAges === void 0 ? void 0 : childrenAges.filter(function(age) {
        return age === 0;
    })) || [];
    var infantCount = lapInfants.length;
    if ((tripType === null || tripType === void 0 ? void 0 : tripType.includes(TripTypes/* FLIGHT */.qQ)) && infantCount > adultCount) {
        return INFANT_CAPACITY_LIMIT;
    }
    return "";
};
function handleIsInfantLimitReachedPackage() {
    var _parent = this.parent, adultCount = _parent.adultCount, childrenAges = _parent.childrenAges, tripType = _parent.tripType;
    if (isInfantLimitReachedPackages(adultCount, childrenAges, tripType)) {
        return false;
    }
    return true;
}
var searchFormSchema = index_esm/* object */.Ry().shape({
    tripType: index_esm/* string */.Z_(),
    partialStay: index_esm/* bool */.Xg(),
    startLocation: index_esm/* object */.Ry().nullable().when("tripType", {
        is: TripTypes/* STAY_DRIVE */.Hl,
        then: function(schema) {
            return schema.nullable();
        },
        otherwise: function(schema) {
            return schema.nullable().required(LOCATION_REQUIRED);
        }
    }),
    endLocation: index_esm/* object */.Ry().nullable().required(LOCATION_REQUIRED),
    rcLocation: index_esm/* object */.Ry().nullable().when("pickupCarSomewhere", {
        is: true,
        then: function(schema) {
            return schema.nullable().required(LOCATION_REQUIRED);
        },
        otherwise: function(schema) {
            return schema.nullable();
        }
    }),
    startDate: index_esm/* string */.Z_().required(INVALID_DATE),
    endDate: index_esm/* string */.Z_().required(INVALID_DATE),
    hotelStartDate: index_esm/* string */.Z_().when("partialStay", {
        is: true,
        then: function(schema) {
            return schema.required(INVALID_DATE);
        }
    }),
    hotelEndDate: index_esm/* string */.Z_().when("partialStay", {
        is: true,
        then: function(schema) {
            return schema.required(INVALID_DATE);
        }
    }),
    rcPickupDate: index_esm/* string */.Z_().when("pickupCarSomewhere", {
        is: true,
        then: function(schema) {
            return schema.nullable().required(INVALID_DATE);
        }
    }),
    rcDropoffDate: index_esm/* string */.Z_().when("pickupCarSomewhere", {
        is: true,
        then: function(schema) {
            return schema.nullable().required(INVALID_DATE);
        }
    }),
    isInfantOnInternationalTravel: index_esm/* string */.Z_().test("isInfantOnInternationalTravel", DISALLOW_INFANT_INTL_FLIGHT, handleIsInfantOnInternationalTravel),
    isChildrenAgeProvided: index_esm/* string */.Z_().test("isChildrenAgeProvided", CHILD_AGE_REQUIRED, handleIsChildrenAgeProvided),
    isRoomCompacityReached: index_esm/* string */.Z_().test("isRoomCompacityReached", BUNDLE_MAX_CAPACITY_ERROR, handleIsRoomCompacityReached),
    isInfantLimitReachedPackages: index_esm/* string */.Z_().test("isInfantLimitReachedPackages", INFANT_CAPACITY_LIMIT, handleIsInfantLimitReachedPackage)
});

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
;// CONCATENATED MODULE: ./src/components/Packages/SearchForm/FormContainer.tsx







function FormContainer(param) {
    var children = param.children, initialState = param.initialState, onSubmit = param.onSubmit, fields = param.fields, searchFormSchema = param.searchFormSchema;
    var ref = (0,dist_index_esm/* useForm */.cI)({
        defaultValues: initialState,
        mode: "onSubmit",
        resolver: (0,yup/* yupResolver */.X)(searchFormSchema),
        reValidateMode: "onChange"
    }), register = ref.register, unregister = ref.unregister, setValue = ref.setValue, clearErrors = ref.clearErrors, formState = ref.formState, handleSubmit = ref.handleSubmit, watch = ref.watch;
    var errors = formState.errors;
    (0,react.useEffect)(function() {
        fields.forEach(function(name) {
            register(name);
        });
        return function() {
            fields.forEach(function(name) {
                unregister(name);
            });
        };
    }, [
        fields,
        register,
        unregister
    ]);
    var ref1 = watch(), watchTripType = ref1.tripType, watchPartialStay = ref1.partialStay, watchStartLocation = ref1.startLocation, watchEndLocation = ref1.endLocation, watchStartDate = ref1.startDate, watchEndDate = ref1.endDate, watchRoomCount = ref1.roomCount, watchAdultCount = ref1.adultCount, watchChildrenAges = ref1.childrenAges, watchChildrenCount = ref1.childrenCount, watchHotelStartDate = ref1.hotelStartDate, watchHotelEndDate = ref1.hotelEndDate, watchPickupCarSomewhere = ref1.pickupCarSomewhere, watchPickupCarIncludeAirport = ref1.pickupCarIncludeAirport, watchRcLocation = ref1.rcLocation, watchRcPickupDate = ref1.rcPickupDate, watchRcDropoffDate = ref1.rcDropoffDate, watchRcPickupTime = ref1.rcPickupTime, watchRcDropoffTime = ref1.rcDropoffTime, watchGaCategory = ref1.gaCategory;
    (0,react.useEffect)(function() {
        clearErrors("startLocation");
    }, [
        clearErrors,
        watchStartLocation
    ]);
    (0,react.useEffect)(function() {
        clearErrors("endLocation");
    }, [
        clearErrors,
        watchEndLocation
    ]);
    (0,react.useEffect)(function() {
        clearErrors("rcLocation");
    }, [
        clearErrors,
        watchRcLocation
    ]);
    (0,react.useEffect)(function() {
        clearErrors("startDate");
    }, [
        clearErrors,
        watchStartDate
    ]);
    (0,react.useEffect)(function() {
        clearErrors("endDate");
    }, [
        clearErrors,
        watchEndDate
    ]);
    (0,react.useEffect)(function() {
        clearErrors("hotelStartDate");
    }, [
        clearErrors,
        watchHotelStartDate,
        watchPartialStay
    ]);
    (0,react.useEffect)(function() {
        clearErrors("hotelEndDate");
    }, [
        clearErrors,
        watchHotelEndDate,
        watchPartialStay
    ]);
    (0,react.useEffect)(function() {
        clearErrors("rcPickupDate");
    }, [
        clearErrors,
        watchRcPickupDate
    ]);
    (0,react.useEffect)(function() {
        clearErrors("rcDropoffDate");
    }, [
        clearErrors,
        watchRcDropoffDate
    ]);
    (0,react.useEffect)(function() {
        clearErrors("isInfantOnInternationalTravel");
    }, [
        clearErrors,
        watchStartLocation,
        watchEndLocation,
        watchChildrenAges
    ]);
    (0,react.useEffect)(function() {
        clearErrors("isChildrenAgeProvided");
    }, [
        clearErrors,
        watchChildrenCount,
        watchChildrenAges
    ]);
    (0,react.useEffect)(function() {
        clearErrors("isRoomCompacityReached");
    }, [
        clearErrors,
        watchAdultCount,
        watchChildrenCount,
        watchTripType,
        watchRoomCount
    ]);
    (0,react.useEffect)(function() {
        if (watchPickupCarSomewhere) clearErrors("rcDropoffDate");
    }, [
        clearErrors,
        watchPickupCarSomewhere
    ]);
    var pathname = (0,router.useRouter)().pathname;
    var ANALYTICS_CATEGORY = constants_analytics/* ANALYTICS_CATEGORIES */.ZP[pathname];
    (0,react.useEffect)(function() {
        setValue("gaCategory", ANALYTICS_CATEGORY);
    }, [
        setValue,
        ANALYTICS_CATEGORY
    ]);
    (0,react.useEffect)(function() {
        if (formState.submitCount && !formState.isValid) {
            analytics/* default.fireEvent */.Z.fireEvent({
                category: ANALYTICS_CATEGORY,
                action: "VP Search Button",
                label: constants_analytics/* INVALID */.UI
            });
        }
    }, [
        formState.isValid,
        formState.submitCount,
        ANALYTICS_CATEGORY
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        "aria-label": "packages-search-form",
        onSubmit: handleSubmit(onSubmit),
        children: children({
            setValue: setValue,
            errors: errors,
            register: register,
            watchState: {
                watchTripType: watchTripType,
                watchAdultCount: watchAdultCount,
                watchRoomCount: watchRoomCount,
                watchChildrenAges: watchChildrenAges,
                watchChildrenCount: watchChildrenCount,
                watchHotelStartDate: watchHotelStartDate,
                watchHotelEndDate: watchHotelEndDate,
                watchStartDate: watchStartDate,
                watchEndDate: watchEndDate,
                watchPartialStay: watchPartialStay,
                watchStartLocation: watchStartLocation,
                watchEndLocation: watchEndLocation,
                watchPickupCarSomewhere: watchPickupCarSomewhere,
                watchPickupCarIncludeAirport: watchPickupCarIncludeAirport,
                watchRcLocation: watchRcLocation,
                watchRcPickupDate: watchRcPickupDate,
                watchRcDropoffDate: watchRcDropoffDate,
                watchRcPickupTime: watchRcPickupTime,
                watchRcDropoffTime: watchRcDropoffTime,
                watchGaCategory: watchGaCategory
            }
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Packages/SearchForm/Form.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  &::-ms-expand {\n    display: none;\n  }\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

























var InlineBlockBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-ad673c1-0"
})(_templateObject());
var FlexLabel = (0,styled_components_browser_esm/* default */.ZP)(Label/* default */.Z).withConfig({
    componentId: "sc-ad673c1-1"
})(_templateObject1());
var trackOneWayFlightLinkClick = function() {
    analytics/* default.fireEvent */.Z.fireEvent({
        action: "Search Form Link",
        label: "I need a one-way flight"
    });
};
var StyledSelect = (0,styled_components_browser_esm/* default */.ZP)(Select/* default */.Z).withConfig({
    componentId: "sc-ad673c1-2"
})(_templateObject2(), theme/* theme.colors.white */.rS.colors.white);
function TimeField(_param) {
    var name = _param.name, label = _param.label, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormField/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                id: name,
                name: name,
                children: (0,date_helper/* getTimeOptions */.wU)()
            }))
        ]
    });
}
var formatOneWayHref = function(param) {
    var watchTripType = param.watchTripType, startLocation = param.watchStartLocation, endLocation = param.watchEndLocation, watchStartDate = param.watchStartDate, watchEndDate = param.watchEndDate, watchRoomCount = param.watchRoomCount, watchAdultCount = param.watchAdultCount, watchChildrenCount = param.watchChildrenCount, watchChildrenAges = param.watchChildrenAges, watchHotelStartDate = param.watchHotelStartDate, watchHotelEndDate = param.watchHotelEndDate, watchPartialStay = param.watchPartialStay;
    var stringifiedQuery = query_string.stringify((0,_object_spread/* default */.Z)({
        "flight-code": "OW",
        "trip-type": watchTripType,
        "origin-item": startLocation === null || startLocation === void 0 ? void 0 : startLocation.itemName,
        "origin-id": startLocation === null || startLocation === void 0 ? void 0 : startLocation.id,
        "origin-type": startLocation === null || startLocation === void 0 ? void 0 : startLocation.type,
        "origin-city": startLocation === null || startLocation === void 0 ? void 0 : startLocation.cityName,
        "origin-state": startLocation === null || startLocation === void 0 ? void 0 : startLocation.provinceName,
        "origin-state-code": startLocation === null || startLocation === void 0 ? void 0 : startLocation.stateCode,
        "origin-country": startLocation === null || startLocation === void 0 ? void 0 : startLocation.country,
        "origin-country-code": startLocation === null || startLocation === void 0 ? void 0 : startLocation.countryCode,
        "destination-item": endLocation === null || endLocation === void 0 ? void 0 : endLocation.itemName,
        "destination-id": endLocation === null || endLocation === void 0 ? void 0 : endLocation.id,
        "destination-type": endLocation === null || endLocation === void 0 ? void 0 : endLocation.type,
        "destination-city": endLocation === null || endLocation === void 0 ? void 0 : endLocation.cityName,
        "destination-state": endLocation === null || endLocation === void 0 ? void 0 : endLocation.provinceName,
        "destination-state-code": endLocation === null || endLocation === void 0 ? void 0 : endLocation.stateCode,
        "destination-country": endLocation === null || endLocation === void 0 ? void 0 : endLocation.country,
        "destination-country-code": endLocation === null || endLocation === void 0 ? void 0 : endLocation.countryCode,
        start: watchStartDate,
        end: watchEndDate,
        rooms: watchRoomCount,
        adults: watchAdultCount,
        children: watchChildrenCount,
        ages: JSON.stringify(watchChildrenAges)
    }, watchPartialStay ? {
        "hotel-start": watchHotelStartDate,
        "hotel-end": watchHotelEndDate
    } : {}));
    return "/shop/search/trips/?".concat(stringifiedQuery);
};
function Form(param) {
    var onSubmit = param.onSubmit, _isLandingPage = param.isLandingPage, isLandingPage = _isLandingPage === void 0 ? true : _isLandingPage;
    var ref = (0,useTabGroup/* default */.Z)(), registerTabElement = ref.registerTabElement, focusNextElement = ref.focusNextElement;
    var ref1 = (0,react.useContext)(BootstrapDataContext/* default */.Z), customer = ref1.customer, _isMobile = ref1.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, webstats = ref1.webstats;
    var ref2 = (0,react.useState)(false), isCalendarOpen = ref2[0], setIsCalendarOpen = ref2[1];
    var ref3 = (0,react.useState)(false), isRcPickupCalendarOpen = ref3[0], setIsRcPickupCalendarOpen = ref3[1];
    var ref4 = (0,react.useState)(false), isRcDropoffCalendarOpen = ref4[0], setIsRcDropoffCalendarOpen = ref4[1];
    var ref5 = (0,react.useState)(false), isHotelCalendarOpen = ref5[0], setIsHotelCalendarOpen = ref5[1];
    var primaryHeadingText = "Save up to $625 on your ";
    var buttonText = "Find Your Trip";
    var callToAction = "Book a hotel, flight or car with free cancellation for flexibility";
    var radioExperimentInitialState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, utils/* initialState */.E3), {
        tripType: TripTypes/* STAY_FLY */.b
    });
    var searchForm = (0,useContentfulSearchFormHeadlines/* default */.Z)("searchForm");
    var maxDaysHotelToSelect = 30;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContainer, {
        onSubmit: onSubmit,
        fields: utils/* fields */.XU,
        initialState: radioExperimentInitialState,
        searchFormSchema: searchFormSchema,
        children: function(param) {
            var setValue = param.setValue, errors = param.errors, register = param.register, _watchState = param.watchState, watchTripType = _watchState.watchTripType, watchAdultCount = _watchState.watchAdultCount, watchRoomCount = _watchState.watchRoomCount, watchChildrenAges = _watchState.watchChildrenAges, watchChildrenCount = _watchState.watchChildrenCount, watchHotelStartDate = _watchState.watchHotelStartDate, watchHotelEndDate = _watchState.watchHotelEndDate, watchStartDate = _watchState.watchStartDate, watchEndDate = _watchState.watchEndDate, watchPartialStay = _watchState.watchPartialStay, watchStartLocation = _watchState.watchStartLocation, watchEndLocation = _watchState.watchEndLocation, watchPickupCarSomewhere = _watchState.watchPickupCarSomewhere, watchRcLocation = _watchState.watchRcLocation, watchRcPickupDate = _watchState.watchRcPickupDate, watchRcDropoffDate = _watchState.watchRcDropoffDate, watchRcPickupTime = _watchState.watchRcPickupTime, watchRcDropoffTime = _watchState.watchRcDropoffTime;
            var finalPrimaryHeadingText = (0,utils/* getTextString */.GS)(watchTripType)(primaryHeadingText);
            var contentfulHeadline = isMobile ? searchForm === null || searchForm === void 0 ? void 0 : searchForm.mobileHeadline : searchForm === null || searchForm === void 0 ? void 0 : searchForm.headline;
            var headline = contentfulHeadline || finalPrimaryHeadingText;
            var carLocationLabel = "City, Airport or Address";
            var rudderstack = {
                "data-rudder-event": true,
                "data-sub-type": "search",
                "data-cguid": webstats.clientGUID,
                "data-parent-product": watchTripType,
                "data-source": isLandingPage ? "package landing" : "homepage",
                "data-email-address": customer.emailAddress
            };
            var maxDaysToSelect = !(0,TripTypes/* hasHotel */.$l)(watchTripType) ? 330 : maxDaysHotelToSelect;
            var childAgeSelectors = {
                optionsText: {
                    infant: (0,TripTypes/* hasFlight */.SL)(watchTripType) ? "0-1 infant in lap" : "Infant",
                    oneYear: (0,TripTypes/* hasFlight */.SL)(watchTripType) ? "0-1 infant in seat" : "1 year old"
                }
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isLandingPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading/* default */.Z, {
                        pb: 1,
                        tag: "h1",
                        color: "text.heading",
                        text: headline,
                        textStyle: [
                            "heading3",
                            null,
                            null,
                            null,
                            "heading2"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm_TripTypeRadios, {
                                watchTripType: watchTripType,
                                setValue: setValue
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexWrap: "wrap",
                                mx: -2,
                                children: [
                                    !(0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        width: [
                                            1,
                                            null,
                                            1 / 2
                                        ],
                                        px: 2,
                                        mt: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                            enabled: true,
                                            forProperty: "startLocation",
                                            children: function(param) {
                                                var disableShadowState = param.disableShadowState;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                                    searchProduct: "packagesOrigin",
                                                    label: "Where from?",
                                                    placeholder: "Where from?",
                                                    searchKey: "startLocation",
                                                    setValue: setValue,
                                                    errors: errors,
                                                    disableShadowState: disableShadowState,
                                                    defaultSelectedItem: watchStartLocation,
                                                    ref: registerTabElement,
                                                    focusNextElement: focusNextElement
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        width: [
                                            1,
                                            null,
                                            (0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) ? 1 : 1 / 2
                                        ],
                                        px: 2,
                                        mt: [
                                            (0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) ? 3 : 0,
                                            null,
                                            3
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                            enabled: true,
                                            forProperty: "endLocation",
                                            children: function(param) {
                                                var disableShadowState = param.disableShadowState;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                                    searchProduct: "packagesDestination",
                                                    label: "Where to?",
                                                    placeholder: "Where to?",
                                                    searchKey: "endLocation",
                                                    errors: errors,
                                                    setValue: setValue,
                                                    disableShadowState: disableShadowState,
                                                    defaultSelectedItem: watchEndLocation,
                                                    onItemSelect: function(item) {
                                                        // auto-populate RC location if not set yet
                                                        if (!watchRcLocation) {
                                                            setValue("rcLocation", item, {
                                                                shouldDirty: true
                                                            });
                                                        }
                                                    },
                                                    ref: registerTabElement,
                                                    focusNextElement: focusNextElement
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            watchTripType.includes("FLY") && /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineBlockBox, {
                                mt: [
                                    0,
                                    null,
                                    3
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: formatOneWayHref({
                                        watchTripType: watchTripType,
                                        watchStartLocation: watchStartLocation,
                                        watchEndLocation: watchEndLocation,
                                        watchStartDate: watchStartDate,
                                        watchEndDate: watchEndDate,
                                        watchRoomCount: watchRoomCount,
                                        watchAdultCount: watchAdultCount,
                                        watchChildrenCount: watchChildrenCount,
                                        watchChildrenAges: watchChildrenAges,
                                        watchHotelStartDate: watchHotelStartDate,
                                        watchHotelEndDate: watchHotelEndDate,
                                        watchPartialStay: watchPartialStay
                                    }),
                                    target: "_blank",
                                    onClick: trackOneWayFlightLinkClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        fontWeight: "bold",
                                        children: "I need a one-way flight"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexWrap: "wrap",
                                alignItems: "flex-start",
                                mx: -2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: [
                                            1,
                                            null,
                                            null,
                                            null,
                                            2 / 3
                                        ],
                                        flexWrap: "wrap",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                                px: 2,
                                                mt: (0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) && isMobile ? 0 : 3,
                                                width: [
                                                    1,
                                                    null,
                                                    1 / 2
                                                ],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                    enabled: true,
                                                    forProperty: "startDate",
                                                    children: function(param) {
                                                        var disableShadowState = param.disableShadowState;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                                            "data-calendar": true,
                                                            open: isCalendarOpen,
                                                            onDismiss: function() {
                                                                setIsCalendarOpen(false);
                                                                disableShadowState();
                                                            },
                                                            domSelectorForVisuallyContainedElement: utils/* CALENDAR_POPOVER_SELECTOR */.k7,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                                    name: "travelDates",
                                                                    "data-testid": "packages-date-range",
                                                                    label: (0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) ? "Check-in   -   Check-out" : "Departing - Returning",
                                                                    ref: registerTabElement,
                                                                    value: (0,date_helper/* getPackagesDateRange */.Q0)({
                                                                        startDate: watchStartDate,
                                                                        endDate: watchEndDate
                                                                    }),
                                                                    onFocus: function() {
                                                                        setIsCalendarOpen(true);
                                                                    },
                                                                    error: function() {
                                                                        if (errors.startDate) {
                                                                            return errors.startDate.message;
                                                                        }
                                                                        if (errors.endDate) {
                                                                            return errors.endDate.message;
                                                                        }
                                                                    }(),
                                                                    hideTooltip: false,
                                                                    "aria-expanded": isCalendarOpen ? "true" : "false"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                                    roundedCorners: true,
                                                                    mmonthWidthPx: 350,
                                                                    startDate: watchStartDate,
                                                                    endDate: watchEndDate,
                                                                    maxDaysToSelect: maxDaysToSelect,
                                                                    onChange: function(_, param) {
                                                                        var startDate = param.startDate, endDate = param.endDate;
                                                                        if (startDate && endDate) {
                                                                            setIsCalendarOpen(false);
                                                                            disableShadowState();
                                                                        }
                                                                        setValue("startDate", startDate || "", {
                                                                            shouldDirty: true
                                                                        });
                                                                        setValue("endDate", endDate || "", {
                                                                            shouldDirty: true
                                                                        });
                                                                        setValue("hotelStartDate", startDate || "", {
                                                                            shouldDirty: true
                                                                        });
                                                                        setValue("hotelEndDate", endDate || "", {
                                                                            shouldDirty: true
                                                                        });
                                                                        // auto-populate RC dates if not set yet
                                                                        if (!watchRcPickupDate) setValue("rcPickupDate", startDate, {
                                                                            shouldDirty: true
                                                                        });
                                                                        if (!watchRcDropoffDate) setValue("rcDropoffDate", endDate, {
                                                                            shouldDirty: true
                                                                        });
                                                                    },
                                                                    useDefaultFooter: true,
                                                                    onDismiss: function() {
                                                                        setIsCalendarOpen(false);
                                                                        disableShadowState();
                                                                    }
                                                                })
                                                            ]
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                px: 2,
                                                mt: [
                                                    0,
                                                    null,
                                                    3
                                                ],
                                                width: [
                                                    1,
                                                    null,
                                                    1 / 2
                                                ],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                    enabled: true,
                                                    forProperty: "travelers-selection-readonly-input",
                                                    alternativeBlurHandling: true,
                                                    children: function(param) {
                                                        var disableShadowState = param.disableShadowState;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelerSelection/* default */.Z, {
                                                            disclaimer: constants/* VP_DISCLAIMER */.sP,
                                                            onDoneButtonClick: disableShadowState,
                                                            roomCount: watchRoomCount,
                                                            adultCount: watchAdultCount,
                                                            childrenAges: watchChildrenAges,
                                                            childrenCount: watchChildrenCount,
                                                            showChildAgeSelectors: true,
                                                            showRoomMenuItem: (0,TripTypes/* hasHotel */.$l)(watchTripType),
                                                            showSubLabel: false,
                                                            setValue: setValue,
                                                            disableShadowState: disableShadowState,
                                                            isMobile: isMobile,
                                                            error: isInfantOnInternationalTravel(watchStartLocation, watchEndLocation, watchChildrenAges) || isInfantLimitReachedPackages(watchAdultCount, watchChildrenAges, watchTripType) || isChildrenAgeProvided(watchChildrenCount, watchChildrenAges) || isRoomCompacityReached(watchAdultCount, watchChildrenCount),
                                                            infantCount: 0,
                                                            showInfantMenuItem: false,
                                                            showYouthMenuItem: false,
                                                            youthCount: 0,
                                                            childAgeSelectors: childAgeSelectors
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                mt: 2,
                                                width: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        ml: 1,
                                                        flexWrap: [
                                                            "wrap",
                                                            null,
                                                            "nowrap"
                                                        ],
                                                        children: !(0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) && (0,TripTypes/* hasHotel */.$l)(watchTripType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexLabel, {
                                                            nowrap: true,
                                                            fontSize: 0,
                                                            mr: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, (0,_object_spread/* default */.Z)({
                                                                    id: "packages-partial-stay"
                                                                }, register("partialStay"))),
                                                                " ",
                                                                "I only need a hotel for part of my stay"
                                                            ]
                                                        })
                                                    }),
                                                    watchPartialStay && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        width: [
                                                            1,
                                                            null,
                                                            1 / 2
                                                        ],
                                                        mt: 2,
                                                        px: 2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                            enabled: true,
                                                            forProperty: "hotelDates",
                                                            children: function(param) {
                                                                var disableShadowState = param.disableShadowState;
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                                                    "data-hotel-calendar": "true",
                                                                    domSelectorForVisuallyContainedElement: utils/* CALENDAR_POPOVER_SELECTOR */.k7,
                                                                    onDismiss: function() {
                                                                        setIsHotelCalendarOpen(false);
                                                                        disableShadowState();
                                                                    },
                                                                    open: isHotelCalendarOpen,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                                            "aria-expanded": isHotelCalendarOpen ? "true" : "false",
                                                                            error: function() {
                                                                                if (errors.hotelStartDate) {
                                                                                    return errors.hotelStartDate.message;
                                                                                }
                                                                                if (errors.hotelEndDate) {
                                                                                    return errors.hotelEndDate.message;
                                                                                }
                                                                            }(),
                                                                            label: "Check-in - Check-out",
                                                                            name: "hotelDates",
                                                                            onFocus: function() {
                                                                                setIsHotelCalendarOpen(true);
                                                                            },
                                                                            value: (0,date_helper/* getPackagesDateRange */.Q0)({
                                                                                startDate: watchHotelStartDate !== null && watchHotelStartDate !== void 0 ? watchHotelStartDate : null,
                                                                                endDate: watchHotelEndDate !== null && watchHotelEndDate !== void 0 ? watchHotelEndDate : null
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                                            startDate: watchHotelStartDate,
                                                                            endDate: watchHotelEndDate,
                                                                            maxDate: watchEndDate ? (0,date_helper/* addFormattedDays */.r2)(watchEndDate, 1) : date_helper/* defaultMaxDate */.Vo,
                                                                            minDate: watchStartDate || date_helper/* defaultToday */.G4,
                                                                            maxDaysToSelect: maxDaysToSelect,
                                                                            roundedCorners: true,
                                                                            monthWidthPx: 350,
                                                                            onChange: function(_, param) {
                                                                                var startDate = param.startDate, endDate = param.endDate;
                                                                                if (startDate && endDate) {
                                                                                    setIsHotelCalendarOpen(false);
                                                                                    disableShadowState();
                                                                                }
                                                                                setValue("hotelStartDate", startDate || "", {
                                                                                    shouldDirty: true
                                                                                });
                                                                                setValue("hotelEndDate", endDate || "", {
                                                                                    shouldDirty: true
                                                                                });
                                                                            },
                                                                            monthsToShow: watchStartDate && watchEndDate ? 1 : 2,
                                                                            onDismiss: function() {
                                                                                setIsHotelCalendarOpen(false);
                                                                                disableShadowState();
                                                                            },
                                                                            useDefaultFooter: true
                                                                        })
                                                                    ]
                                                                });
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        flexWrap: "wrap",
                                        alignItems: "flex-start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                mt: 2,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexLabel, {
                                                    nowrap: true,
                                                    fontSize: 0,
                                                    ml: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, (0,_object_spread/* default */.Z)({
                                                            id: "packages-pickup-car-somewhere",
                                                            "data-testid": "packages-pickup-car-somewhere"
                                                        }, register("pickupCarSomewhere"))),
                                                        " ",
                                                        "I want to pick up my car somewhere else"
                                                    ]
                                                })
                                            }),
                                            watchPickupCarSomewhere && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                flexWrap: "wrap",
                                                alignItems: "flex-start",
                                                width: [
                                                    1,
                                                    null,
                                                    1
                                                ],
                                                px: 2,
                                                mt: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                        enabled: true,
                                                        forProperty: "rcLocation",
                                                        children: function(param) {
                                                            var disableShadowState = param.disableShadowState;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                                                searchProduct: "cars",
                                                                label: carLocationLabel,
                                                                placeholder: carLocationLabel,
                                                                searchKey: "rcLocation",
                                                                "data-testid": "packages-rc-location",
                                                                errors: errors,
                                                                setValue: setValue,
                                                                disableShadowState: disableShadowState,
                                                                defaultSelectedItem: watchRcLocation !== null && watchRcLocation !== void 0 ? watchRcLocation : null,
                                                                ref: registerTabElement,
                                                                focusNextElement: focusNextElement
                                                            });
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        mt: 2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexLabel, {
                                                            nowrap: true,
                                                            fontSize: 0,
                                                            ml: -2,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, (0,_object_spread/* default */.Z)({
                                                                    id: "packages-pickup-car-include-airport"
                                                                }, register("pickupCarIncludeAirport"))),
                                                                " ",
                                                                "Include airport pick-up and drop-off locations"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        flexWrap: "wrap",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                                                mt: 3,
                                                                width: [
                                                                    1 / 2,
                                                                    null,
                                                                    1 / 4
                                                                ],
                                                                "data-testid": "packages-rc-pickup-date",
                                                                id: "rc-pickup-date",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                                    enabled: true,
                                                                    forProperty: "rcPickupDate",
                                                                    children: function(param) {
                                                                        var disableShadowState = param.disableShadowState;
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                                                            "data-calendar": true,
                                                                            open: isRcPickupCalendarOpen,
                                                                            onDismiss: function() {
                                                                                setIsRcPickupCalendarOpen(false);
                                                                                disableShadowState();
                                                                            },
                                                                            domSelectorForVisuallyContainedElement: utils/* CALENDAR_POPOVER_SELECTOR */.k7,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                                                    name: "rcPickupDate",
                                                                                    label: "Pick-up",
                                                                                    ref: registerTabElement,
                                                                                    value: (0,date_helper/* formatDate */.p6)(watchRcPickupDate !== null && watchRcPickupDate !== void 0 ? watchRcPickupDate : null),
                                                                                    onFocus: function() {
                                                                                        setIsRcPickupCalendarOpen(true);
                                                                                    },
                                                                                    error: function() {
                                                                                        if (errors.rcPickupDate) {
                                                                                            return errors.rcPickupDate.message;
                                                                                        }
                                                                                    }(),
                                                                                    hideTooltip: false,
                                                                                    "aria-expanded": isRcPickupCalendarOpen ? "true" : "false"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                                                    roundedCorners: true,
                                                                                    monthWidthPx: 350,
                                                                                    monthsToShow: 2,
                                                                                    selectTwoDates: false,
                                                                                    maxDate: (0,date_helper/* getRcMaxDate */.U6)(watchRcDropoffDate),
                                                                                    startDate: watchRcPickupDate,
                                                                                    onChange: function(_, param) {
                                                                                        var startDate = param.startDate;
                                                                                        if (startDate) {
                                                                                            setIsRcPickupCalendarOpen(false);
                                                                                            disableShadowState();
                                                                                        }
                                                                                        setValue("rcPickupDate", startDate || "", {
                                                                                            shouldDirty: true
                                                                                        });
                                                                                    },
                                                                                    useDefaultFooter: true,
                                                                                    onDismiss: function() {
                                                                                        setIsRcPickupCalendarOpen(false);
                                                                                        disableShadowState();
                                                                                    }
                                                                                })
                                                                            ]
                                                                        });
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                px: 2,
                                                                mt: 3,
                                                                width: [
                                                                    1 / 2,
                                                                    null,
                                                                    1 / 4
                                                                ],
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                                    enabled: true,
                                                                    forProperty: "rcPickupTime",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeField, {
                                                                        id: "rc-pickup-time",
                                                                        "data-testid": "packages-rc-pickup-time",
                                                                        name: "rcPickupTime",
                                                                        label: "Pick-up Time",
                                                                        style: {
                                                                            height: isMobile ? "46px" : "56px"
                                                                        },
                                                                        value: watchRcPickupTime,
                                                                        onChange: function(e) {
                                                                            setValue("rcPickupTime", e.currentTarget.value);
                                                                            e.target.blur();
                                                                        }
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                                                mt: 3,
                                                                width: [
                                                                    1 / 2,
                                                                    null,
                                                                    1 / 4
                                                                ],
                                                                id: "rc-dropoff-date",
                                                                "data-testid": "packages-rc-dropoff-date",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                                    enabled: true,
                                                                    forProperty: "rcDropoffDate",
                                                                    children: function(param) {
                                                                        var disableShadowState = param.disableShadowState;
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                                                            "data-calendar": true,
                                                                            open: isRcDropoffCalendarOpen,
                                                                            onDismiss: function() {
                                                                                setIsRcDropoffCalendarOpen(false);
                                                                                disableShadowState();
                                                                            },
                                                                            domSelectorForVisuallyContainedElement: utils/* CALENDAR_POPOVER_SELECTOR */.k7,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                                                    name: "rcDropoffDate",
                                                                                    label: "Drop-off",
                                                                                    ref: registerTabElement,
                                                                                    value: (0,date_helper/* formatDate */.p6)(watchRcDropoffDate !== null && watchRcDropoffDate !== void 0 ? watchRcDropoffDate : null),
                                                                                    onFocus: function() {
                                                                                        setIsRcDropoffCalendarOpen(true);
                                                                                    },
                                                                                    error: function() {
                                                                                        if (errors.rcDropoffDate) {
                                                                                            return errors.rcDropoffDate.message;
                                                                                        }
                                                                                    }(),
                                                                                    hideTooltip: false,
                                                                                    "aria-expanded": isRcDropoffCalendarOpen ? "true" : "false"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                                                    monthsToShow: 2,
                                                                                    roundedCorners: true,
                                                                                    monthWidthPx: 350,
                                                                                    selectTwoDates: false,
                                                                                    minDate: (0,date_helper/* getRcMinDate */.D$)(watchRcPickupDate),
                                                                                    startDate: watchRcDropoffDate,
                                                                                    onChange: function(_, param) {
                                                                                        var startDate = param.startDate;
                                                                                        if (startDate) {
                                                                                            setIsRcDropoffCalendarOpen(false);
                                                                                            disableShadowState();
                                                                                        }
                                                                                        setValue("rcDropoffDate", startDate || "", {
                                                                                            shouldDirty: true
                                                                                        });
                                                                                    },
                                                                                    useDefaultFooter: true,
                                                                                    onDismiss: function() {
                                                                                        setIsRcDropoffCalendarOpen(false);
                                                                                        disableShadowState();
                                                                                    }
                                                                                })
                                                                            ]
                                                                        });
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                px: 2,
                                                                mt: 3,
                                                                width: [
                                                                    1 / 2,
                                                                    null,
                                                                    1 / 4
                                                                ],
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                                    enabled: true,
                                                                    forProperty: "rcDropoffTime",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeField, {
                                                                        id: "rc-dropoff-time",
                                                                        name: "rcDropoffTime",
                                                                        "data-testid": "packages-rc-dropoff-time",
                                                                        label: "Drop-off Time",
                                                                        style: {
                                                                            height: isMobile ? "46px" : "56px"
                                                                        },
                                                                        value: watchRcDropoffTime,
                                                                        onChange: function(e) {
                                                                            setValue("rcDropoffTime", e.currentTarget.value);
                                                                            e.target.blur();
                                                                        }
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                flexWrap: "wrap",
                                                width: [
                                                    1,
                                                    null,
                                                    null,
                                                    null,
                                                    1
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        width: [
                                                            1,
                                                            null,
                                                            1 / 2
                                                        ],
                                                        px: 2,
                                                        mt: 3,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFormButton/* default */.Z, (0,_object_spread/* default */.Z)({
                                                            buttonText: buttonText,
                                                            isMobile: isMobile,
                                                            "data-testid": "find-your-trip-button"
                                                        }, rudderstack))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        width: [
                                                            1,
                                                            null,
                                                            0.4
                                                        ],
                                                        px: 2,
                                                        mt: 3,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                                            fontSize: "12px",
                                                            mt: 2,
                                                            children: callToAction
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !(0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        flexDirection: "column",
                                        width: [
                                            1,
                                            null,
                                            null,
                                            null,
                                            1 / 3
                                        ],
                                        px: 2,
                                        mt: 3,
                                        ml: "auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFormButton/* default */.Z, (0,_object_spread/* default */.Z)({
                                                buttonText: buttonText,
                                                isMobile: isMobile,
                                                "data-testid": "find-your-trip-button"
                                            }, rudderstack)),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                                fontSize: "12px",
                                                mt: 2,
                                                children: callToAction
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
}
/* harmony default export */ var SearchForm_Form = (Form);


/***/ }),

/***/ 29657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68464);


var useGeoPosition = function() {
    var locale = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(locale.longitude ? locale.longitude : null), longitude = ref[0], setLongitude = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(locale.latitude ? locale.latitude : null), latitude = ref1[0], setLatitude = ref1[1];
    var onSuccess = function(param) {
        var coords = param.coords;
        setLongitude(coords.longitude);
        setLatitude(coords.latitude);
    };
    var onError = function() {
    // TODO: fail silently or log error
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var geo = navigator.geolocation;
        if (!geo) {
            // TODO: potentially log error
            return;
        }
        geo.getCurrentPosition(onSuccess, onError);
    }, []);
    return {
        longitude: longitude,
        latitude: latitude
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGeoPosition);


/***/ }),

/***/ 964:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var fireRudderstackEvent = function(rudderstack) {
    if (rudderstack.subType) {
        var ref;
        var event = rudderstack.subType;
        (ref = window.rudderanalytics) === null || ref === void 0 ? void 0 : ref.track(event, rudderstack);
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (fireRudderstackEvent);


/***/ })

}]);